import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule],
  template: `
    <ul class="layout-menu">
      <ng-container *ngFor="let item of model; let i = index">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
      </ng-container>
    </ul>
  `
})
export class AppMenu {
  model: MenuItem[] = [];

  ngOnInit() {
    this.model = [
      {
        label: 'Home',
        items: [
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }
        ]
      },
      {
        label: 'Reconciliation',
        icon: 'pi pi-fw pi-chart-line',
        items: [
          { label: 'Reconcile', icon: 'pi pi-fw pi-play', routerLink: ['/reconciliation'] },
          { label: 'Transactions', icon: 'pi pi-fw pi-list', routerLink: ['/reconciliation/transactions'] },
          { label: 'Purchase Orders', icon: 'pi pi-fw pi-shopping-cart', routerLink: ['/reconciliation/purchase-orders'] },
          { label: 'Rule Management', icon: 'pi pi-fw pi-cog', routerLink: ['/reconciliation/rule-management'] },
          { label: 'Manual Reconciliation Ledger', icon: 'pi pi-fw pi-book', routerLink: ['/reconciliation/manual-reconciliation-ledger'] },
          //{ label: 'Test Components', icon: 'pi pi-fw pi-cog', routerLink: ['/reconciliation/test-components'] }
        ]
      },
      {
        label: 'Portal',
        icon: 'pi pi-fw pi-globe',
        items: [
          { label: 'Portal Management', icon: 'pi pi-fw pi-briefcase', routerLink: ['/portal'] },
          // { label: 'Portal Users', icon: 'pi pi-fw pi-users', routerLink: ['/portal/portal-users'] }
        ]
      },
      {
        label: 'Company',
        icon: 'pi pi-fw pi-building',
        items: [
          { label: 'Business Entities', icon: 'pi pi-fw pi-sitemap', routerLink: ['/company'] },
          { label: 'Members', icon: 'pi pi-fw pi-user', routerLink: ['/members'] }
        ]
      },
      {
        label: 'Bank',
        icon: 'pi pi-fw pi-credit-card',
        items: [
          { label: 'Financial Institutions', icon: 'pi pi-fw pi-building', routerLink: ['/banks'] },
          { label: 'Credit Cards', icon: 'pi pi-fw pi-wallet', routerLink: ['/credit-cards'] },
          { label: 'CC Transactions', icon: 'pi pi-fw pi-sync', routerLink: ['/cc-transactions'] }
        ]
      },
      {
        label: 'Administration',
        icon: 'pi pi-fw pi-cog',
        items: [
          { label: 'Audit Trail', icon: 'pi pi-fw pi-history', routerLink: ['/audit-trail'] },
          { label: 'Report Generator', icon: 'pi pi-fw pi-file-export', routerLink: ['/report-generation'] }
        ]
      }
    ];
  }
}
